import { LevelOrder } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a LevelOrder.
 *
 * @param obj - The value to check
 * @returns True if the value is a LevelOrder
 */
export const isLevelOrder = (obj: unknown): obj is LevelOrder => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  if (typeof obj.level !== "number") return false;
  if (typeof obj.order !== "number") return false;
  // Everything is good
  return true;
};
